import { render, staticRenderFns } from "./FeedBackView.vue?vue&type=template&id=95dd28ea&"
import script from "./FeedBackView.vue?vue&type=script&lang=js&"
export * from "./FeedBackView.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports